var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-state"},[_vm._v("Could not display component. Kindly check your internet connection.")])}
var staticRenderFns = []

export { render, staticRenderFns }